export const customTabsMockedData = {
  'tabs-adults': {
    tabs: [
      // ==========================================
      // Tab 1: DOLOR DE CABEZA
      // ==========================================
      {
        button: {
          label: 'DOLOR DE CABEZA',
          ariaLabel: 'DOLOR DE CABEZA',
        },
        image: {
          src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt2ad1d5318b91eab9/6a3982b64ad7bba4becc45fa/f1b92b92fa6c39e370c23e4ca8318c348fa81609.png',
          altText: 'Mujer con dolor intenso de cabeza',
        },
        tabContent: [
          // SLIDER 1: TEMPRA FEN
          {
            backgroundColor: 'red',
            heading: 'TEMPRA FEN<sup>®</sup>',
            subHeading: 'LA RÁPIDA AYUDA PARA ALIVIAR EL DOLOR DE CABEZA',
            description: '¡No le des más tiempo al dolor de cabeza!',
            image: {
              src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/bltba1cfc2dc0667e29/6a3981cc02803445feaff27b/TEMPRA-FEN-TULUM_10T_G.png',
              altText: 'Medicamento Tempra Fen 400mg con 20 tabletas',
            },
            disclaimer:
              '^vs tabletas regulares Data on file: NL 1307 *La cápsula se desintegra en 1 minuto para iniciar su absorción. Claim memo No: SORL 50034/001; 2018. Project California report 50034. data on file: NL 1307. Lea las instrucciones de uso. SI PERSISTEN LAS MOLESTIAS, CONSULTE A SU MÉDICO. No se administre a menores de 12 años ni durante embarazo o lactancia. 243300201B2001 Reg. San. No. 088M2016 SSA VI',
            button: {
              label: 'Ver más',
              ariaLabel: 'Ver más',
              link: '/adultos/productos/temprafen/',
            },
            icons: [
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt2a6bea0f0e5dde7f/6a514411bdc6ed151fb1cf7b/ico-8hrs-rojo.svg',
                  altText: 'Icono de efectivo durante 8 horas',
                },
                heading: 'Efectivo hasta por 8 h',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blta2080ad00882e588/6a30420cae7a22707f225d66/ico-1min-rojo.svg',
                  altText: 'Icono de cronometro marcando un minuto',
                },
                heading: 'Se activa en 1 minuto*',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/bltba317d2894607f7b/6a30420cdbd35f1a791f7c57/ico-2xAbsrocion.svg',
                  altText: 'Icono que simboliza absorción rápida',
                },
                heading: 'Absorción 2x más rápida^',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt5b7d2bfef9c3d78c/6a30420c9f9e173b3ad78495/ico-fen400mg.svg',
                  altText: 'Icono de pastillas de Ibuprofeno',
                },
                heading: '400 mg de Ibuprofeno',
              },
            ],
          },
          // SLIDER 2: TEMPRA FORTE
          {
            backgroundColor: 'red',
            heading: 'TEMPRA FORTE<sup>®</sup>',
            subHeading: 'AUXILIAR PARA DOLOR CORPORAL​',
            description:
              'Si el dolor o la fiebre llegan sin avisar, ¡atiéndelos con ayuda de Tempra Forte<sup>®</sup>!',
            image: {
              src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/bltbcfe752b64da1b8e/6a5e8777651b134aadb23f4c/TEMPRA-FORTE-650MG-24T_Tableta.png',
              altText: 'TEMPRA FORTE',
            },
            disclaimer:
              '1.F. J. Arroyo, et al. Estrategias de tratamiento analgésico tras cesárea. Estado actual y nuevas alternativas. Rev Esp Anestesiol Reanim. 2020;67(3):167-175. SI PERSISTEN LAS MOLESTIAS, CONSULTE A SU MÉDICO. LEA LAS INSTRUCCIONES DE USO. Permiso de Publicidad No. 203300201B1062. Reg. San. 128M99 SSA VI.',
            button: {
              label: 'Ver más',
              ariaLabel: 'Ver más',
              link: '/adultos/productos/tempra-forte-paracetamol/',
            },
            icons: [
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt2a6bea0f0e5dde7f/6a514411bdc6ed151fb1cf7b/ico-8hrs-rojo.svg',
                  altText: '8 hours',
                },
                heading: 'Actúa hasta por 8 h¹',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/bltc88d3bcb4d298379/6a60c9c0d8b46cb7608c22c9/tamaños_250_(1).svg',
                  altText: 'Icono de ayuda a dolor y fiebre',
                },
                heading: 'Auxiliar para el dolor y la fiebre',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt5a8d0dea20e4b1bc/6a5e35915efbb4a317340284/tamaños_250.svg',
                  altText: 'Icono de pastilla de paracetamol',
                },
                heading: '650 mg de paracetamol',
              },
            ],
          },
          // SLIDER 3: TEMPRA 500
          {
            backgroundColor: 'red',
            heading: 'TEMPRA<sup>®</sup> 500',
            subHeading: 'AUXILIAR EN EL ALIVIO DE LA FIEBRE Y EL DOLOR',
            description:
              'Si la fiebre y el dolor llegan sin avisar, ¡atiéndelos con Tempra<sup>®</sup>!',
            image: {
              src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt980ba4a1741f9395/6a39810546ab0400559c5e35/TEMPRA-500MG-10T_G.png',
              altText: 'Empaque de Tempra 500 mg',
            },
            disclaimer:
              'SI PERSISTEN LAS MOLESTIAS, CONSULTE A SU MÉDICO, LEA LAS INSTRUCCIONES DE USO. Permiso de publicidad No. 203300201B1062. Reg. San. 90865 SSA VI.',
            button: {
              label: 'Ver más',
              ariaLabel: 'Ver más',
              link: '/adultos/productos/tempra-500-mg/',
            },
            icons: [
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt4695230e88989c87/6a2c69056b9ea7677aa55edd/Group.svg',
                  altText: 'Icono 6 horas',
                },
                heading: 'Actúa hasta por 6 horas',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt77d9429bec2015d3/6a2c67b7e6cde6d958b30b6e/ico-termometro-azulF_(1).svg',
                  altText: 'Icono termómetro azul',
                },
                heading: 'Auxiliar para dolor y fiebre',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt3f3162d61aa53056/6a303d9f1082fd00bc56d697/ico-500mg-azul.svg',
                  altText: 'Icono 500 mg paracetamol',
                },
                heading: '500 mg de paracetamol',
              },
            ],
          },
          // SLIDER 4: TEMPRA BOOST
          {
            backgroundColor: 'red',
            heading: 'TEMPRA BOOST<sup>®</sup>',
            subHeading: 'AUXILIAR EN EL ALIVIO DEL DOLOR DE CABEZA OCASIONADO POR ESTRÉS',
            description:
              'Combinación de analgésico más cafeína, que te ayuda a combatir el dolor provocado por un día pesado.',
            image: {
              src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt144ed875203da7ab/6a3981e558a7df28df4b2b56/TEMPRA-BOOST-12T_A.png',
              altText: 'Empaque de Tempra Boost',
            },
            disclaimer:
              '¹Garry G. Graham, et al. The modern pharmacology of paracetamol: therapeutic actions, mechanism of actions, metabolism, toxicity and recent pharmacological findings. Inflammopharmacology. 2013. 21:201-232. SI PERSISTEN LAS MOLESTIAS, CONSULTE A SU MÉDICO, LEA LAS INSTRUCCIONES DE USO. Reg. San. No. 137M99 SSA VI.',
            button: {
              label: 'Ver más',
              ariaLabel: 'Ver más Tempra Boost',
              link: '/adultos/productos/tempra-boost-paracetamol-y-cafeina/',
            },
            icons: [
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt8a6b8c96c0eb55fb/6a3049ffd99d9569e9339089/ico-noIrrita.svg',
                  altText: 'Icono No irrita el estómago',
                },
                heading: 'No irrita el estómago',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt22d8ca9612744167/6a3049fe2a33ff0081561e4c/ico-auxiliarDolor.svg',
                  altText: 'Icono Auxiliar para el dolor',
                },
                heading: 'Auxiliar para el dolor',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt874084f327079bd3/6a3049feae7a226b63225d6e/ico-dobleAccion-rojo.svg',
                  altText: 'Icono Doble acción',
                },
                heading: 'Doble acción Paracetamol + Cafeína',
              },
            ],
          },
        ],
      },
      // ==========================================
      // Tab 2: DOLOR CORPORAL
      // ==========================================
      {
        button: {
          label: 'DOLOR CORPORAL',
          ariaLabel: 'DOLOR CORPORAL',
        },
        image: {
          src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/bltaf18ab3158ae9c6c/6a3982fa604a0da6af962ec7/393a3f2022aa858f6474bf9d9f5f49c3b0f805dc.png',
          altText: 'Hombre atletico con dolor muscular en hombro',
        },
        tabContent: [
          // SLIDER 1: TEMPRA FORTE
          {
            backgroundColor: 'red',
            heading: 'TEMPRA FORTE<sup>®</sup>',
            subHeading: 'AUXILIAR PARA DOLOR CORPORAL​',
            description:
              'Si el dolor o la fiebre llegan sin avisar, ¡atiéndelos con ayuda de Tempra Forte<sup>®</sup>!',
            image: {
              src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/bltbcfe752b64da1b8e/6a5e8777651b134aadb23f4c/TEMPRA-FORTE-650MG-24T_Tableta.png',
              altText: 'TEMPRA FORTE',
            },
            disclaimer:
              '1.F. J. Arroyo, et al. Estrategias de tratamiento analgésico tras cesárea. Estado actual y nuevas alternativas. Rev Esp Anestesiol Reanim. 2020;67(3):167-175. SI PERSISTEN LAS MOLESTIAS, CONSULTE A SU MÉDICO. LEA LAS INSTRUCCIONES DE USO. Permiso de Publicidad No. 203300201B1062. Reg. San. 128M99 SSA VI.',
            button: {
              label: 'Ver más',
              ariaLabel: 'Ver más',
              link: '/adultos/productos/tempra-forte-paracetamol/',
            },
            icons: [
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt2a6bea0f0e5dde7f/6a514411bdc6ed151fb1cf7b/ico-8hrs-rojo.svg',
                  altText: '8 hours',
                },
                heading: 'Actúa hasta por 8 h¹',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/bltc88d3bcb4d298379/6a60c9c0d8b46cb7608c22c9/tamaños_250_(1).svg',
                  altText: 'Icono de ayuda a dolor y fiebre',
                },
                heading: 'Auxiliar para el dolor y la fiebre',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt5a8d0dea20e4b1bc/6a5e35915efbb4a317340284/tamaños_250.svg',
                  altText: 'Icono de pastilla de paracetamol',
                },
                heading: '650 mg de paracetamol',
              },
            ],
          },
          // SLIDER 2: TEMPRA XT NOCHE
          {
            backgroundColor: 'purple',
            heading: 'TEMPRA<sup>®</sup> XT NOCHE',
            subHeading: 'AUXILIAR PARA ALIVIAR EL DOLOR',
            description: 'Analgésico con ayuda adicional para tener un buen descanso.',
            image: {
              src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt91fbbacf21599df6/6a3981b2a79f67221d69a44c/23005-TEMPRA-XT-MOONLIGHT_CAJA-12_A.png',
              altText: 'Medicamento Tempra XT Noche con 12 tabletas',
            },
            disclaimer:
              'SI PERSISTEN LAS MOLESTIAS, CONSULTE A SU MÉDICO. LEA LAS INSTRUCCIONES DE USO. No se administre a menores de 12 años. Permiso de Publicidad No. 233300201B0198. Tempra<sup>®</sup> XT Noche Reg. San. No. 419M2008 SSA VI.',
            button: {
              label: 'Ver más',
              ariaLabel: 'Ver más',
              link: '/adultos/productos/tempra-noche/',
            },
            icons: [
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt3ddcdf1ace27a11d/6a2c60ad812b3c80e08ed189/ico-800mg-morado_(1).svg',
                  altText: 'Icono de pastillas de paracetamol',
                },
                heading: '800 mg de paracetamol',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt7e41477448ed9a7d/6a2c60adbc912e090ad5f7c3/ico-accion-nocturna.svg',
                  altText: 'Icono acción nocturna',
                },
                heading: 'Acción nocturna',
              },
            ],
          },
          // SLIDER 3: TEMPRA 500
          {
            backgroundColor: 'red',
            heading: 'TEMPRA<sup>®</sup> 500',
            subHeading: 'AUXILIAR EN EL ALIVIO DE FIEBRE Y DOLOR',
            description:
              'Si la fiebre y el dolor llegan sin avisar, ¡atiéndelos con Tempra<sup>®</sup>!',
            image: {
              src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt980ba4a1741f9395/6a39810546ab0400559c5e35/TEMPRA-500MG-10T_G.png',
              altText: 'Empaque de Tempra 500 mg',
            },
            disclaimer:
              'SI PERSISTEN LAS MOLESTIAS, CONSULTE A SU MÉDICO, LEA LAS INSTRUCCIONES DE USO. Permiso de publicidad No. 203300201B1062. Reg. San. 90865 SSA VI.',
            button: {
              label: 'Ver más',
              ariaLabel: 'Ver más',
              link: '/adultos/productos/tempra-500-mg/',
            },
            icons: [
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt4695230e88989c87/6a2c69056b9ea7677aa55edd/Group.svg',
                  altText: 'Icono 6 horas',
                },
                heading: 'Actúa hasta por 6 horas',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt77d9429bec2015d3/6a2c67b7e6cde6d958b30b6e/ico-termometro-azulF_(1).svg',
                  altText: 'Icono termómetro azul',
                },
                heading: 'Auxiliar para dolor y fiebre',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt3f3162d61aa53056/6a303d9f1082fd00bc56d697/ico-500mg-azul.svg',
                  altText: 'Icono 500 mg paracetamol',
                },
                heading: '500 mg de paracetamol',
              },
            ],
          },
          // SLIDER 4: TEMPRA FEN
          {
            backgroundColor: 'red',
            heading: 'TEMPRA FEN<sup>®</sup>',
            subHeading: 'LA RÁPIDA AYUDA PARA ALIVIAR EL DOLOR DE CABEZA',
            description: '¡No le des más tiempo al dolor de cabeza!',
            image: {
              src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/bltba1cfc2dc0667e29/6a3981cc02803445feaff27b/TEMPRA-FEN-TULUM_10T_G.png',
              altText: 'Medicamento Tempra Fen 400mg con 20 tabletas',
            },
            disclaimer:
              '^vs tabletas regulares Data on file: NL 1307 *La cápsula se desintegra en 1 minuto para iniciar su absorción. Claim memo No: SORL 50034/001; 2018. Project California report 50034. data on file: NL 1307. Lea las instrucciones de uso. SI PERSISTEN LAS MOLESTIAS, CONSULTE A SU MÉDICO. No se administre a menores de 12 años ni durante embarazo o lactancia. 243300201B2001 Reg. San. No. 088M2016 SSA VI',
            button: {
              label: 'Ver más',
              ariaLabel: 'Ver más',
              link: '/adultos/productos/temprafen/',
            },
            icons: [
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt2a6bea0f0e5dde7f/6a514411bdc6ed151fb1cf7b/ico-8hrs-rojo.svg',
                  altText: 'Icono de efectivo durante 8 horas',
                },
                heading: 'Efectivo hasta por 8 h',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blta2080ad00882e588/6a30420cae7a22707f225d66/ico-1min-rojo.svg',
                  altText: 'Icono de cronometro marcando un minuto',
                },
                heading: 'Se activa en 1 minuto*',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/bltba317d2894607f7b/6a30420cdbd35f1a791f7c57/ico-2xAbsrocion.svg',
                  altText: 'Icono que simboliza absorción rápida',
                },
                heading: 'Absorción 2x más rápida^',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt5b7d2bfef9c3d78c/6a30420c9f9e173b3ad78495/ico-fen400mg.svg',
                  altText: 'Icono de pastillas de Ibuprofeno',
                },
                heading: '400 mg de Ibuprofeno',
              },
            ],
          },
        ],
      },
      // ==========================================
      // Tab 3: RESFRIADO
      // ==========================================
      {
        button: {
          label: 'RESFRIADO',
          ariaLabel: 'RESFRIADO',
        },
        image: {
          src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blte015c1a902df7dc5/6a3982befac998a653ab7c51/f0e78e0d82e6a76f45d9d76e33d6846c987eec07.png',
          altText: 'Hombre enfermo tapado con manta roja',
        },
        tabContent: [
          // SLIDER 1: TEMPRA 24hrs
          {
            backgroundColor: 'red',
            heading: 'TEMPRA<sup>®</sup> 24hrs',
            subHeading: 'AUXILIAR PARA EL ALIVIO DE LOS SÍNTOMAS DE RESFRIADO',
            description:
              'Alivio al despertar y descansa al dormir con la ayuda de Tempra<sup>®</sup> 24hrs.',
            image: {
              src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/bltf658b554784590cf/6a3980d9cf11cd0470b7020b/TEMPRA-24HRS-24T_A.png',
              altText: 'Medicamento Tempra 24 horas con 24 tabletas',
            },
            disclaimer:
              '*Carbinoxamina solo en toma de la noche. Neubauer DN, Pandi-Perumal SR, Spence DW, Buttoo K, Monti JM. Pharmacotherapy of insomnia. Journal of Central Nervous System Disease. 2018; 10:1-7. 2. Cooper et. al., Efficacy and tolerability studies evaluating a sleep aid and analgesic combination of naproxen sodium and diphenhydramine in the dental impaction pain model in subject with introduces transien insomnia. Int J Clin Pract. 205; 69 (10):11-49-1158. Si persisten las molestias, consulte a su médico. Lea las instrucciones de uso. No se administre a menores de 12 años. Tempra<sup>®</sup> XT Día Reg. San. No. 467M2008 SSA VI. Tempra<sup>®</sup> XT Noche Reg. No. 419M2008 SSA VI. Permiso de Publicidad No. 203300201B1062.',
            button: {
              label: 'Ver más',
              ariaLabel: 'Ver más Tempra 24hrs',
              link: '/adultos/productos/tempra-24hrs/',
            },
            icons: [
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt02ed347582afa448/6a3044d6716cb428f39f29ba/ico-resfriado.svg',
                  altText: 'Icono de persona con bufanda',
                },
                heading: 'Auxiliar para síntomas del resfriado común',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blta38520905d37a2ed/6a3044d6992703789b26ba66/ico-alivioDescanso.svg',
                  altText: 'Icono de luna y sol con reloj nocturno',
                },
                heading: 'Alivio al despertar y descanso al dormir*',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt09baccac53e35cb6/6a3044d6338dfff6c4e3dacf/ico-sinsomnolencia.svg',
                  altText: 'Icono de sol brillante',
                },
                heading: 'Sin somnolencia durante el día*',
              },
            ],
          },
          // SLIDER 2: TEMPRA FORTE
          {
            backgroundColor: 'red',
            heading: 'TEMPRA FORTE<sup>®</sup>',
            subHeading: 'AUXILIAR PARA DOLOR CORPORAL​',
            description:
              'Si el dolor o la fiebre llegan sin avisar, ¡atiéndelos con ayuda de Tempra Forte<sup>®</sup>!',
            image: {
              src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/bltbcfe752b64da1b8e/6a5e8777651b134aadb23f4c/TEMPRA-FORTE-650MG-24T_Tableta.png',
              altText: 'TEMPRA FORTE',
            },
            disclaimer:
              '1.F. J. Arroyo, et al. Estrategias de tratamiento analgésico tras cesárea. Estado actual y nuevas alternativas. Rev Esp Anestesiol Reanim. 2020;67(3):167-175. SI PERSISTEN LAS MOLESTIAS, CONSULTE A SU MÉDICO. LEA LAS INSTRUCCIONES DE USO. Permiso de Publicidad No. 203300201B1062. Reg. San. 128M99 SSA VI.',
            button: {
              label: 'Ver más',
              ariaLabel: 'Ver más',
              link: '/adultos/productos/tempra-forte-paracetamol/',
            },
            icons: [
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt2a6bea0f0e5dde7f/6a514411bdc6ed151fb1cf7b/ico-8hrs-rojo.svg',
                  altText: '8 hours',
                },
                heading: 'Actúa hasta por 8 h¹',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/bltc88d3bcb4d298379/6a60c9c0d8b46cb7608c22c9/tamaños_250_(1).svg',
                  altText: 'Icono de ayuda a dolor y fiebre',
                },
                heading: 'Auxiliar para el dolor y la fiebre',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt5a8d0dea20e4b1bc/6a5e35915efbb4a317340284/tamaños_250.svg',
                  altText: 'Icono de pastilla de paracetamol',
                },
                heading: '650 mg de paracetamol',
              },
            ],
          },
          // SLIDER 3: TEMPRA 500
          {
            backgroundColor: 'red',
            heading: 'TEMPRA<sup>®</sup> 500',
            subHeading: 'AUXILIAR EN EL ALIVIO DE LA FIEBRE Y EL DOLOR',
            description:
              'Si la fiebre y el dolor llegan sin avisar, ¡atiéndelos con Tempra<sup>®</sup>!',
            image: {
              src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt980ba4a1741f9395/6a39810546ab0400559c5e35/TEMPRA-500MG-10T_G.png',
              altText: 'Empaque de Tempra 500 mg',
            },
            disclaimer:
              'SI PERSISTEN LAS MOLESTIAS, CONSULTE A SU MÉDICO, LEA LAS INSTRUCCIONES DE USO. Permiso de publicidad No. 203300201B1062. Reg. San. 90865 SSA VI.',
            button: {
              label: 'Ver más',
              ariaLabel: 'Ver más',
              link: '/adultos/productos/tempra-500-mg/',
            },
            icons: [
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt4695230e88989c87/6a2c69056b9ea7677aa55edd/Group.svg',
                  altText: 'Icono 6 horas',
                },
                heading: 'Actúa hasta por 6 horas',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt77d9429bec2015d3/6a2c67b7e6cde6d958b30b6e/ico-termometro-azulF_(1).svg',
                  altText: 'Icono termómetro azul',
                },
                heading: 'Auxiliar para dolor y fiebre',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt3f3162d61aa53056/6a303d9f1082fd00bc56d697/ico-500mg-azul.svg',
                  altText: 'Icono 500 mg paracetamol',
                },
                heading: '500 mg de paracetamol',
              },
            ],
          },
          // SLIDER 4: TEMPRA XT NOCHE
          {
            backgroundColor: 'purple',
            heading: 'TEMPRA<sup>®</sup> XT NOCHE',
            subHeading: 'AUXILIAR PARA ALIVIAR EL DOLOR',
            description: 'Analgésico con ayuda adicional para tener un buen descanso.',
            image: {
              src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt91fbbacf21599df6/6a3981b2a79f67221d69a44c/23005-TEMPRA-XT-MOONLIGHT_CAJA-12_A.png',
              altText: 'Medicamento Tempra XT Noche con 12 tabletas',
            },
            disclaimer:
              'SI PERSISTEN LAS MOLESTIAS, CONSULTE A SU MÉDICO. LEA LAS INSTRUCCIONES DE USO. No se administre a menores de 12 años. Permiso de Publicidad No. 233300201B0198. Tempra<sup>®</sup> XT Noche Reg. San. No. 419M2008 SSA VI.',
            button: {
              label: 'Ver más',
              ariaLabel: 'Ver más',
              link: '/adultos/productos/tempra-noche/',
            },
            icons: [
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt3ddcdf1ace27a11d/6a2c60ad812b3c80e08ed189/ico-800mg-morado_(1).svg',
                  altText: 'Icono de pastillas de paracetamol',
                },
                heading: '800 mg de paracetamol',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt7e41477448ed9a7d/6a2c60adbc912e090ad5f7c3/ico-accion-nocturna.svg',
                  altText: 'Icono acción nocturna',
                },
                heading: 'Acción nocturna',
              },
            ],
          },
        ],
      },
    ],
  },
  // ==========================================
  // KIDS TABS
  // ==========================================
  'tempra-kidstabs': {
    tabs: [
      // ==========================================
      // Tab 1: DOLOR DE CABEZA
      // ==========================================
      {
        button: {
          label: 'DOLOR DE CABEZA',
          ariaLabel: 'DOLOR DE CABEZA',
        },
        image: {
          src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/bltec284dfa0f9c70c4/6a399957bb6755774c02d321/f6798a87c7f1aa3ebeb8a00ce5cfa0e555709b8f.png',
          altText: 'Niño con dolor de cabeza',
        },
        tabContent: [
          // Slider 1: Jarabe 120ml
          {
            backgroundColor: 'blue',
            heading: 'TEMPRA<sup>®</sup> JARABE',
            subHeading: 'AUXILIAR PARA FIEBRE Y DOLOR',
            description:
              'Tempra<sup>®</sup>, tu auxiliar de confianza para aliviar a tus pequeños.',
            image: {
              src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt9fb516723ed08bc0/6a71b042d692d3ddf566f354/carousel-2.png',
              altText: 'Medicamento Tempra Jarabe para niños junto a fresas frescas',
            },
            disclaimer:
              'SI PERSISTEN LAS MOLESTIAS, CONSULTE A SU MÉDICO. NO SE DEJE AL ALCANCE DE LOS NIÑOS. LEA LA ETIQUETA DEL PRODUCTO ANTES DE UTILIZARLO. Permiso de publicidad No. 203300201B1062. Reg. San. 48690 SSA VI​.',
            button: {
              label: 'VER MÁS',
              ariaLabel: 'Ver más Tempra Jarabe',
              link: '/ninos/productos/tempra-jarabe-infantil-120-ml/',
            },
            icons: [
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt4695230e88989c87/6a2c69056b9ea7677aa55edd/Group.svg',
                  altText: 'Icono de alivio hasta por 6 horas',
                },
                heading: 'Actúa hasta por 6 h',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt040762475bcf01d0/6a2c67b7812b3c8a3c8ed19a/ico-paraninios2a11_(1).svg',
                  altText: 'Icono de niña alegre',
                },
                heading: 'Para niños de 2 a 11 años',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt77d9429bec2015d3/6a2c67b7e6cde6d958b30b6e/ico-termometro-azulF_(1).svg',
                  altText: 'Icono de alivio al dolor y la fiebre',
                },
                heading: 'Auxiliar para fiebre y dolor',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt9c2124494861d9bf/6a2c67b75f1b73dd399d4254/ico-saborFresa_(1).svg',
                  altText: 'Icono de medicamento en Jarabe Tempra sabor fresa',
                },
                heading: 'Sabor a fresa',
              },
            ],
          },
          // Slider 2: Tempra-Fen
          {
            backgroundColor: 'yellow',
            heading: 'TEMPRA-FEN<sup>®</sup>',
            subHeading: 'AUXILIAR PARA DOLOR, FIEBRE E INFLAMACIÓN',
            description:
              'Si tu pequeño se siente mal, confía en Tempra-Fen®, que ayuda a aliviar 3 síntomas en 15 minutos¹.',
            image: {
              src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt4c7073d6dce912ab/6a71b042a4d5b84834377f1a/carousel-1.png',
              altText: 'Medicamento Tempra-fen niños',
            },
            disclaimer:
              '1Pelen F et al. Treatment of fever: Monotherapy with ibuprofen. Ibuprofen pediatric suspension containing 100 mg/5 ml, multicentre acceptability study conducted in hospital. ANN PEDIATR. 1998; 45(10): 719−728. 2de Martino, et al. Working Towards an Appropriate Use of Ibuprofen in Children: An Evidence-Based Appraisal. Drugs. 2017; 77: 1295-1311. *No contiene sacarosa. Formula en el Reg. San. No. 092M2016 SSA VI. SI PERSISTEN LAS MOLESTIAS, CONSULTE A SU MÉDICO. No se deje al alcance de los niños. Lea la etiqueta del producto antes de utilizarlo.',
            button: {
              label: 'VER MÁS',
              ariaLabel: 'Ver más Tempra-Fen',
              link: '/ninos/productos/tempra-fen-ibuprofeno/',
            },
            icons: [
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt3988ac32550e0c0b/6a2c6de28ad5d7a8254e3d6d/ico_15min-naranja.svg',
                  altText: 'Icono 15 minutos',
                },
                heading: 'Actúa en 15 min*',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt9039be10a3d607c2/6a2c6f0d910feacdf8f2534d/ico-8hrs-naranja.svg',
                  altText: 'Icono 8 horas',
                },
                heading: 'Hasta por 8 h',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt306d1208e426a6f7/6a2c6de235de77d2e34ef2c1/ico-sinAzucar-anaranja.svg',
                  altText: 'Icono sin azúcar',
                },
                heading: 'Sin azúcar*',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt417b1c1edc3d69d8/6a2c6de2910fea1591f25345/ico-jeringaDosif-naranja.svg',
                  altText: 'Icono jeringa',
                },
                heading: 'Con jeringa dosificadora',
              },
            ],
          },
          // Slider 3: Masticable 4-6
          {
            backgroundColor: 'blue',
            heading: 'TEMPRA<sup>®</sup> MASTICABLE',
            subHeading: 'AUXILIAR PARA EL ALIVIO DE FIEBRE Y DOLOR.',
            description:
              '¿Tu pequeño tiene fiebre o dolor? ¡No te preocupes! Confía en Tempra<sup>®</sup>',
            image: {
              src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/bltcdf242d40330717e/6a71b0425c637049f7106ebd/carousel-3.png',
              altText: 'Tempra masticable 4 a 6 años',
            },
            disclaimer:
              'SI PERSISTEN LAS MOLESTIAS, CONSULTE A SU MÉDICO. No se deje al alcance de los niños. Lea las instrucciones de uso in el empaque. Reg. San. No. 039M84 SSA. VI.',
            button: {
              label: 'VER MÁS',
              ariaLabel: 'Ver más Tempra Masticable 4-6',
              link: '/ninos/productos/tempra-tableta-masticable-infantil-30-tabletas-80mg/',
            },
            icons: [
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt8eb4bf86d4de3487/6a2cd46ebcf977d09a2d0df8/ico-paraninios.svg',
                  altText: 'Icono niños',
                },
                heading: 'Para niños de 4 a 6 años',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt4695230e88989c87/6a2c69056b9ea7677aa55edd/Group.svg',
                  altText: 'Icono 6 horas',
                },
                heading: 'Actúa hasta por 6 h',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt06d196adaf98a993/6a2cd55c8ad5d7928f4e3d8f/ico-tablMasticables.svg',
                  altText: 'Icono tabletas',
                },
                heading: 'Tabletas masticables',
              },
            ],
          },
          // Slider 4: Masticable 6-11
          {
            backgroundColor: 'blue',
            heading: 'TEMPRA<sup>®</sup> MASTICABLE',
            subHeading: 'AUXILIAR PARA EL ALIVIO DE FIEBRE Y DOLOR.',
            description:
              'Con la ayuda de Tempra<sup>®</sup> ni el dolor ni la fiebre detendrán a tus pequeños.',
            image: {
              src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt58db9e42255755a5/6a71b04242103f544e72df0a/carousel-4.png',
              altText: 'Medicamento Tempra Tabletas masticables 160mg',
            },
            disclaimer:
              'SI PERSISTEN LAS MOLESTIAS, CONSULTE A SU MÉDICO. No se deje al alcance de los niños. Lea la etiqueta del producto antes de utilizarlo. Reg. San. No. 039M84 SSA VI.',
            button: {
              label: 'VER MÁS',
              ariaLabel: 'Ver más Tempra Masticable 6-11',
              link: '/ninos/productos/tempra-tableta-masticable-infantil-30-tabletas-160mg/',
            },
            icons: [
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt073093fb79e137f9/6a3054adbc747e0aba4d5fc5/ico-paraninios6a11.svg',
                  altText: 'Icono niños grandes',
                },
                heading: 'Para niños de 6 a 11 años',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt4695230e88989c87/6a2c69056b9ea7677aa55edd/Group.svg',
                  altText: 'Icono 6 horas',
                },
                heading: 'Actúa hasta por 6 h',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt06d196adaf98a993/6a2cd55c8ad5d7928f4e3d8f/ico-tablMasticables.svg',
                  altText: 'Icono tabletas',
                },
                heading: 'Tabletas masticables',
              },
            ],
          },
        ],
      },
      // =========================================================================
      // Tab: DOLOR DENTAL
      // =========================================================================
      {
        button: {
          label: 'DOLOR DENTAL',
          ariaLabel: 'DOLOR DENTAL',
        },
        image: {
          src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/bltb00fa7d598ef5302/6a305c73338dff672ce3daeb/a6fdfc4dd98b04cedd94467df1b773d6116a322e.png',
          altText: 'Niño señalando su diente con dolor dental',
        },
        tabContent: [
          // Slider 1: Solución Pediátrica
          {
            backgroundColor: 'blue',
            heading: 'TEMPRA<sup>®</sup> SOLUCIÓN PEDIÁTRICA',
            subHeading: 'AUXILIAR PARA EL ALIVIO DE FIEBRE Y DOLOR.',
            description: '¿Tu bebé se siente mal? Tempra<sup>®</sup> gotas le ayuda a aliviarlo.',
            image: {
              src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/bltd455963bcb0aa689/6a71b04406284c408c93a4fe/carousel-5.png',
              altText: 'Empaque de Tempra Solución Pediátrica Gotas',
            },
            disclaimer:
              'SI PERSISTEN LAS MOLESTIAS, CONSULTE A SU MÉDICO. No se deje al alcance de los niños. Lea la etiqueta del producto antes de utilizarlo. Reg. San. No. 039M84 SSA VI.',
            button: {
              label: 'VER MÁS',
              ariaLabel: 'Ver más Tempra Gotas',
              link: '/ninos/productos/tempra-solucion-pediatrica-30-ml/',
            },
            icons: [
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt388c9c65fa06e661/6a305d49d99d95db073390ad/ico-paraBebes.svg',
                  altText: 'Icono de 0 a 36 meses',
                },
                heading: 'Para niños de 0 a 36 meses',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt22a49d794b6cdd23/6a305d49722edc969297f8f8/ico-gotero-azul.svg',
                  altText: 'Icono gotero azul',
                },
                heading: 'Con gotero integrado',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt4695230e88989c87/6a2c69056b9ea7677aa55edd/Group.svg',
                  altText: 'Icono 6 horas',
                },
                heading: 'Actúa hasta por 6 h',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/bltf71a6a1aa9e9e925/6a305e1f6db5a4b9f7ed70b2/ico-15min-azul.svg',
                  altText: 'Icono 15 minutos',
                },
                heading: 'Actúa en 15 min',
              },
            ],
          },
          // Slider 2: Tempra-Fen
          {
            backgroundColor: 'yellow',
            heading: 'TEMPRA-FEN<sup>®</sup>',
            subHeading: 'AUXILIAR PARA DOLOR, FIEBRE E INFLAMACIÓN',
            description:
              'Si tu pequeño se siente mal, confía en Tempra-Fen®, que ayuda a aliviar 3 síntomas en 15 minutos¹.',
            image: {
              src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt4c7073d6dce912ab/6a71b042a4d5b84834377f1a/carousel-1.png',
              altText: 'Medicamento Tempra-fen niños',
            },
            disclaimer:
              '¹Pelen F et al. Treatment of fever: Monotherapy withibuprofen. Ibuprofen pediatric suspension containing100 mg/5 ml, multicentre acceptability studyconducted in hospital. ANN PEDIATR. 1998; 45(10):719−728. 2de Martino, et al. Working Towards anAppropriate Use of Ibuprofen in Children: AnEvidence-Based Appraisal. Drugs. 2017; 77: 1295-1311.*No contiene sacarosa. Formula en el Reg. San. No.092M2016 SSA VI.SI PERSISTEN LAS MOLESTIAS, CONSULTE A SUMÉDICO. No se deje al alcance de los niños. Lea laetiqueta del producto antes de utilizarlo. Reg. San.No. 092M2016 SSA VI.',
            button: {
              label: 'VER MÁS',
              ariaLabel: 'Ver más Tempra-Fen',
              link: '/ninos/productos/tempra-fen-ibuprofeno/',
            },
            icons: [
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt3988ac32550e0c0b/6a2c6de28ad5d7a8254e3d6d/ico_15min-naranja.svg',
                  altText: 'Icono 15 min',
                },
                heading: 'Actúa en 15 min*',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt9039be10a3d607c2/6a2c6f0d910feacdf8f2534d/ico-8hrs-naranja.svg',
                  altText: 'Icono 8h',
                },
                heading: 'Hasta por 8 h',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt306d1208e426a6f7/6a2c6de235de77d2e34ef2c1/ico-sinAzucar-anaranja.svg',
                  altText: 'Icono sin azúcar',
                },
                heading: 'Sin azúcar*',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt417b1c1edc3d69d8/6a2c6de2910fea1591f25345/ico-jeringaDosif-naranja.svg',
                  altText: 'Icono jeringa',
                },
                heading: 'Con jeringa dosificadora',
              },
            ],
          },
          // Slider 3: Masticable 4-6
          {
            backgroundColor: 'blue',
            heading: 'TEMPRA<sup>®</sup> MASTICABLE',
            subHeading: 'AUXILIAR PARA EL ALIVIO DE FIEBRE Y DOLOR.',
            description:
              '¿Tu pequeño tiene fiebre o dolor? ¡No te preocupes! Confía en Tempra<sup>®</sup>',
            image: {
              src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/bltcdf242d40330717e/6a71b0425c637049f7106ebd/carousel-3.png',
              altText: 'Tempra masticable 4 a 6 años',
            },
            disclaimer:
              'SI PERSISTEN LAS MOLESTIAS, CONSULTE A SU MÉDICO. No se deje al alcance de los niños. Lea las instrucciones de uso in el empaque. Reg. San. No. 039M84 SSA. VI.',
            button: {
              label: 'VER MÁS',
              ariaLabel: 'Ver más Tempra Masticable 4-6',
              link: '/ninos/productos/tempra-tableta-masticable-infantil-30-tabletas-80mg/',
            },
            icons: [
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt8eb4bf86d4de3487/6a2cd46ebcf977d09a2d0df8/ico-paraninios.svg',
                  altText: 'Icono niños',
                },
                heading: 'Para niños de 4 a 6 años',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt4695230e88989c87/6a2c69056b9ea7677aa55edd/Group.svg',
                  altText: 'Icono 6 h',
                },
                heading: 'Actúa hasta por 6 h',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt06d196adaf98a993/6a2cd55c8ad5d7928f4e3d8f/ico-tablMasticables.svg',
                  altText: 'Icono tabletas',
                },
                heading: 'Tabletas masticables',
              },
            ],
          },
          // Slider 4: Masticable 6-11
          {
            backgroundColor: 'blue',
            heading: 'TEMPRA<sup>®</sup> MASTICABLE',
            subHeading: 'AUXILIAR PARA EL ALIVIO DE FIEBRE Y DOLOR.',
            description:
              'Con la ayuda de Tempra<sup>®</sup> ni el dolor ni la fiebre detendrán a tus pequeños.',
            image: {
              src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt58db9e42255755a5/6a71b04242103f544e72df0a/carousel-4.png',
              altText: 'Medicamento Tempra Tabletas masticables 160mg',
            },
            disclaimer:
              'SI PERSISTEN LAS MOLESTIAS, CONSULTE A SU MÉDICO. No se deje al alcance de los niños. Lea la etiqueta del producto antes de utilizarlo. Reg. San. No. 039M84 SSA VI.',
            button: {
              label: 'VER MÁS',
              ariaLabel: 'Ver más Tempra Masticable 6-11',
              link: '/ninos/productos/tempra-tableta-masticable-infantil-30-tabletas-160mg/',
            },
            icons: [
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt073093fb79e137f9/6a3054adbc747e0aba4d5fc5/ico-paraninios6a11.svg',
                  altText: 'Icono niños grandes',
                },
                heading: 'Para niños de 6 a 11 años',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt4695230e88989c87/6a2c69056b9ea7677aa55edd/Group.svg',
                  altText: 'Icono 6 h',
                },
                heading: 'Actúa hasta por 6 h',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt06d196adaf98a993/6a2cd55c8ad5d7928f4e3d8f/ico-tablMasticables.svg',
                  altText: 'Icono tabletas',
                },
                heading: 'Tabletas masticables',
              },
            ],
          },
        ],
      },
      // =========================================================================
      // Tab: DOLOR DE GARGANTA
      // =========================================================================
      {
        button: {
          label: 'DOLOR DE GARGANTA',
          ariaLabel: 'DOLOR DE GARGANTA',
        },
        image: {
          src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/bltef9f6bd99424730b/6a54ff3afd87c7616c2b43a5/862a80c0393f8b5bf2b40abc2a12b5d3b2aa1445_(1)_-_Editado.png',
          altText: 'Niño con dolor de garganta',
        },
        tabContent: [
          // Slider 1: Jarabe 120ml
          {
            backgroundColor: 'blue',
            heading: 'TEMPRA<sup>®</sup> JARABE',
            subHeading: 'AUXILIAR PARA FIEBRE Y DOLOR',
            description:
              'Tempra<sup>®</sup>, tu auxiliar de confianza para aliviar a tus pequeños.',
            image: {
              src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt9fb516723ed08bc0/6a71b042d692d3ddf566f354/carousel-2.png',
              altText: 'Medicamento Tempra Jarabe para niños junto a fresas frescas',
            },
            disclaimer:
              'SI PERSISTEN LAS MOLESTIAS, CONSULTE A SU MÉDICO. NO SE DEJE AL ALCANCE DE LOS NIÑOS. LEA LA ETIQUETA DEL PRODUCTO ANTES DE UTILIZARLO. Permiso de publicidad No. 203300201B1062. Reg. San. 48690 SSA VI.',
            button: {
              label: 'VER MÁS',
              ariaLabel: 'Ver más Tempra Jarabe',
              link: '/ninos/productos/tempra-jarabe-infantil-120-ml/',
            },
            icons: [
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt4695230e88989c87/6a2c69056b9ea7677aa55edd/Group.svg',
                  altText: 'Icono de alivio hasta por 6 horas',
                },
                heading: 'Actúa hasta por 6 h',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt040762475bcf01d0/6a2c67b7812b3c8a3c8ed19a/ico-paraninios2a11_(1).svg',
                  altText: 'Icono de niña alegre',
                },
                heading: 'Para niños de 2 a 11 años',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt77d9429bec2015d3/6a2c67b7e6cde6d958b30b6e/ico-termometro-azulF_(1).svg',
                  altText: 'Icono de alivio al dolor y la fiebre',
                },
                heading: 'Auxiliar para fiebre y dolor',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt9c2124494861d9bf/6a2c67b75f1b73dd399d4254/ico-saborFresa_(1).svg',
                  altText: 'Icono de medicamento en Jarabe Tempra sabor fresa',
                },
                heading: 'Sabor a fresa',
              },
            ],
          },
          // Slider 2: Tempra-Fen
          {
            backgroundColor: 'yellow',
            heading: 'TEMPRA-FEN<sup>®</sup>',
            subHeading: 'AUXILIAR PARA DOLOR, FIEBRE E INFLAMACIÓN',
            description:
              'Si tu pequeño se siente mal, confía en Tempra-Fen®, que ayuda a aliviar 3 síntomas en 15 minutos¹.',
            image: {
              src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt4c7073d6dce912ab/6a71b042a4d5b84834377f1a/carousel-1.png',
              altText: 'Medicamento Tempra-fen niños',
            },
            disclaimer:
              '¹Pelen F et al. Treatment of fever: Monotherapy withibuprofen. Ibuprofen pediatric suspension containing100 mg/5 ml, multicentre acceptability studyconducted in hospital. ANN PEDIATR. 1998; 45(10):719−728. 2de Martino, et al. Working Towards anAppropriate Use of Ibuprofen in Children: AnEvidence-Based Appraisal. Drugs. 2017; 77: 1295-1311.*No contiene sacarosa. Formula en el Reg. San. No.092M2016 SSA VI.SI PERSISTEN LAS MOLESTIAS, CONSULTE A SUMÉDICO. No se deje al alcance de los niños. Lea laetiqueta del producto antes de utilizarlo. Reg. San.No. 092M2016 SSA VI.',
            button: {
              label: 'VER MÁS',
              ariaLabel: 'Ver más Tempra-Fen',
              link: '/ninos/productos/tempra-fen-ibuprofeno/',
            },
            icons: [
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt3988ac32550e0c0b/6a2c6de28ad5d7a8254e3d6d/ico_15min-naranja.svg',
                  altText: 'Icono 15 min',
                },
                heading: 'Actúa en 15 min*',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt9039be10a3d607c2/6a2c6f0d910feacdf8f2534d/ico-8hrs-naranja.svg',
                  altText: 'Icono 8h',
                },
                heading: 'Hasta por 8 h',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt306d1208e426a6f7/6a2c6de235de77d2e34ef2c1/ico-sinAzucar-anaranja.svg',
                  altText: 'Icono sin azúcar',
                },
                heading: 'Sin azúcar*',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt417b1c1edc3d69d8/6a2c6de2910fea1591f25345/ico-jeringaDosif-naranja.svg',
                  altText: 'Icono jeringa',
                },
                heading: 'Con jeringa dosificadora',
              },
            ],
          },
          // Slider 3: Masticable 4-6
          {
            backgroundColor: 'blue',
            heading: 'TEMPRA<sup>®</sup> MASTICABLE',
            subHeading: 'AUXILIAR PARA EL ALIVIO DE FIEBRE Y DOLOR.',
            description:
              '¿Tu pequeño tiene fiebre o dolor? ¡No te preocupes! Confía en Tempra<sup>®</sup>',
            image: {
              src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/bltcdf242d40330717e/6a71b0425c637049f7106ebd/carousel-3.png',
              altText: 'Tempra masticable 4 a 6 años',
            },
            disclaimer:
              'SI PERSISTEN LAS MOLESTIAS, CONSULTE A SU MÉDICO. No se deje al alcance de los niños. Lea las instrucciones de uso in el empaque. Reg. San. No. 039M84 SSA. VI.',
            button: {
              label: 'VER MÁS',
              ariaLabel: 'Ver más Tempra Masticable 4-6',
              link: '/ninos/productos/tempra-tableta-masticable-infantil-30-tabletas-80mg/',
            },
            icons: [
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt8eb4bf86d4de3487/6a2cd46ebcf977d09a2d0df8/ico-paraninios.svg',
                  altText: 'Icono niños',
                },
                heading: 'Para niños de 4 a 6 años',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt4695230e88989c87/6a2c69056b9ea7677aa55edd/Group.svg',
                  altText: 'Icono 6 h',
                },
                heading: 'Actúa hasta por 6 h',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt06d196adaf98a993/6a2cd55c8ad5d7928f4e3d8f/ico-tablMasticables.svg',
                  altText: 'Icono tabletas',
                },
                heading: 'Tabletas masticables',
              },
            ],
          },
          // Slider 4: Masticable 6-11
          {
            backgroundColor: 'blue',
            heading: 'TEMPRA<sup>®</sup> MASTICABLE',
            subHeading: 'AUXILIAR PARA EL ALIVIO DE FIEBRE Y DOLOR.',
            description:
              'Con la ayuda de Tempra<sup>®</sup> ni el dolor ni la fiebre detendrán a tus pequeños.',
            image: {
              src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt58db9e42255755a5/6a71b04242103f544e72df0a/carousel-4.png',
              altText: 'Medicamento Tempra Tabletas masticables 160mg',
            },
            disclaimer:
              'SI PERSISTEN LAS MOLESTIAS, CONSULTE A SU MÉDICO. No se deje al alcance de los niños. Lea la etiqueta del producto antes de utilizarlo. Reg. San. No. 039M84 SSA VI.',
            button: {
              label: 'VER MÁS',
              ariaLabel: 'Ver más Tempra Masticable 6-11',
              link: '/ninos/productos/tempra-tableta-masticable-infantil-30-tabletas-160mg/',
            },
            icons: [
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt073093fb79e137f9/6a3054adbc747e0aba4d5fc5/ico-paraninios6a11.svg',
                  altText: 'Icono niños grandes',
                },
                heading: 'Para niños de 6 a 11 años',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt4695230e88989c87/6a2c69056b9ea7677aa55edd/Group.svg',
                  altText: 'Icono 6 h',
                },
                heading: 'Actúa hasta por 6 h',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt06d196adaf98a993/6a2cd55c8ad5d7928f4e3d8f/ico-tablMasticables.svg',
                  altText: 'Icono tabletas',
                },
                heading: 'Tabletas masticables',
              },
            ],
          },
        ],
      },
      // ==========================================
      // Tab 2: DOLOR POR CRECIMIENTO
      // ==========================================
      {
        button: {
          label: 'DOLOR POR CRECIMIENTO',
          ariaLabel: 'DOLOR POR CRECIMIENTO',
        },
        image: {
          src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt877600b6e0eda48a/6a54ff39e91cf51618faa28f/1e55361b-989c-4c9e-84dc-694bc955dcc9.png',
          altText: 'Niña con dolor por crecimiento',
        },
        tabContent: [
          // Slider 1: Tempra-Fen
          {
            backgroundColor: 'yellow',
            heading: 'TEMPRA-FEN<sup>®</sup>',
            subHeading: 'AUXILIAR PARA DOLOR, FIEBRE E INFLAMACIÓN',
            description:
              'Si tu pequeño se siente mal, confía en Tempra-Fen®, que ayuda a aliviar 3 síntomas en 15 minutos¹.',
            image: {
              src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt4c7073d6dce912ab/6a71b042a4d5b84834377f1a/carousel-1.png',
              altText: 'Medicamento Tempra-fen niños',
            },
            disclaimer:
              '¹Pelen F et al. Treatment of fever: Monotherapy withibuprofen. Ibuprofen pediatric suspension containing100 mg/5 ml, multicentre acceptability studyconducted in hospital. ANN PEDIATR. 1998; 45(10):719−728. 2de Martino, et al. Working Towards anAppropriate Use of Ibuprofen in Children: AnEvidence-Based Appraisal. Drugs. 2017; 77: 1295-1311.*No contiene sacarosa. Formula en el Reg. San. No.092M2016 SSA VI.SI PERSISTEN LAS MOLESTIAS, CONSULTE A SUMÉDICO. No se deje al alcance de los niños. Lea laetiqueta del producto antes de utilizarlo. Reg. San.No. 092M2016 SSA VI.',
            button: {
              label: 'VER MÁS',
              ariaLabel: 'Ver más Tempra-Fen',
              link: '/ninos/productos/tempra-fen-ibuprofeno/',
            },
            icons: [
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt3988ac32550e0c0b/6a2c6de28ad5d7a8254e3d6d/ico_15min-naranja.svg',
                  altText: 'Icono 15 min',
                },
                heading: 'Actúa en 15 min*',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt9039be10a3d607c2/6a2c6f0d910feacdf8f2534d/ico-8hrs-naranja.svg',
                  altText: 'Icono 8h',
                },
                heading: 'Hasta por 8 h',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt306d1208e426a6f7/6a2c6de235de77d2e34ef2c1/ico-sinAzucar-anaranja.svg',
                  altText: 'Icono sin azúcar',
                },
                heading: 'Sin azúcar*',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt417b1c1edc3d69d8/6a2c6de2910fea1591f25345/ico-jeringaDosif-naranja.svg',
                  altText: 'Icono jeringa',
                },
                heading: 'Con jeringa dosificadora',
              },
            ],
          },
          // Slider 2: Tempra Jarabe
          {
            backgroundColor: 'blue',
            heading: 'TEMPRA<sup>®</sup> JARABE',
            subHeading: 'AUXILIAR PARA EL DOLOR DE GARGANTA',
            description:
              'Tempra<sup>®</sup>, tu auxiliar de confianza para aliviar a tus pequeños.',
            image: {
              src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt9fb516723ed08bc0/6a71b042d692d3ddf566f354/carousel-2.png',
              altText: 'Medicamento Tempra Jarabe para niños',
            },
            disclaimer:
              'SI PERSISTEN LAS MOLESTIAS, CONSULTE A SU MÉDICO. NO SE DEJE AL ALCANCE DE LOS NIÑOS. LEA LA ETIQUETA DEL PRODUCTO ANTES DE UTILIZARLO. Permiso de publicidad No. 203300201B1062. Reg. San. 48690 SSA VI​.',
            button: {
              label: 'VER MÁS',
              ariaLabel: 'Ver más Tempra Jarabe',
              link: '/ninos/productos/tempra-jarabe-infantil-120-ml/',
            },
            icons: [
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt4695230e88989c87/6a2c69056b9ea7677aa55edd/Group.svg',
                  altText: '6h',
                },
                heading: 'Actúa hasta por 6 h',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt040762475bcf01d0/6a2c67b7812b3c8a3c8ed19a/ico-paraninios2a11_(1).svg',
                  altText: 'niños',
                },
                heading: 'Para niños de 2 a 11 años',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt77d9429bec2015d3/6a2c67b7e6cde6d958b30b6e/ico-termometro-azulF_(1).svg',
                  altText: 'termometro',
                },
                heading: 'Auxiliar para fiebre y dolor',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt9c2124494861d9bf/6a2c67b75f1b73dd399d4254/ico-saborFresa_(1).svg',
                  altText: 'fresa',
                },
                heading: 'Sabor a fresa',
              },
            ],
          },
          // Slider 3: Masticable 4-6
          {
            backgroundColor: 'blue',
            heading: 'TEMPRA<sup>®</sup> MASTICABLE',
            subHeading: 'AUXILIAR PARA EL ALIVIO DE FIEBRE Y DOLOR.',
            description:
              '¿Tu pequeño tiene fiebre o dolor? ¡No te preocupes! Confía en Tempra<sup>®</sup>',
            image: {
              src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/bltcdf242d40330717e/6a71b0425c637049f7106ebd/carousel-3.png',
              altText: 'Tempra masticable 4 a 6 años',
            },
            disclaimer:
              'SI PERSISTEN LAS MOLESTIAS, CONSULTE A SU MÉDICO. No se deje al alcance de los niños. Lea las instrucciones de uso in el empaque. Reg. San. No. 039M84 SSA. VI.',
            button: {
              label: 'VER MÁS',
              ariaLabel: 'Ver más Tempra Masticable 4-6',
              link: '/ninos/productos/tempra-tableta-masticable-infantil-30-tabletas-80mg/',
            },
            icons: [
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt8eb4bf86d4de3487/6a2cd46ebcf977d09a2d0df8/ico-paraninios.svg',
                  altText: 'niños',
                },
                heading: 'Para niños de 4 a 6 años',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt4695230e88989c87/6a2c69056b9ea7677aa55edd/Group.svg',
                  altText: '6h',
                },
                heading: 'Actúa hasta por 6 h',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt06d196adaf98a993/6a2cd55c8ad5d7928f4e3d8f/ico-tablMasticables.svg',
                  altText: 'tabletas',
                },
                heading: 'Tabletas masticables',
              },
            ],
          },
          // Slider 4: Masticable 6-11
          {
            backgroundColor: 'blue',
            heading: 'TEMPRA<sup>®</sup> MASTICABLE',
            subHeading: 'AUXILIAR PARA EL ALIVIO DE FIEBRE Y DOLOR.',
            description:
              'Con la ayuda de Tempra<sup>®</sup> ni el dolor ni la fiebre detendrán a tus pequeños.',
            image: {
              src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt58db9e42255755a5/6a71b04242103f544e72df0a/carousel-4.png',
              altText: 'Medicamento Tempra Tabletas masticables 160mg',
            },
            disclaimer:
              'SI PERSISTEN LAS MOLESTIAS, CONSULTE A SU MÉDICO. No se deje al alcance de los niños. Lea la etiqueta del producto antes de utilizarlo. Reg. San. No. 039M84 SSA VI.',
            button: {
              label: 'VER MÁS',
              ariaLabel: 'Ver más Tempra Masticable 6-11',
              link: '/ninos/productos/tempra-tableta-masticable-infantil-30-tabletas-160mg/',
            },
            icons: [
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt073093fb79e137f9/6a3054adbc747e0aba4d5fc5/ico-paraninios6a11.svg',
                  altText: 'niños grandes',
                },
                heading: 'Para niños de 6 a 11 años',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt4695230e88989c87/6a2c69056b9ea7677aa55edd/Group.svg',
                  altText: '6h',
                },
                heading: 'Actúa hasta por 6 h',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt06d196adaf98a993/6a2cd55c8ad5d7928f4e3d8f/ico-tablMasticables.svg',
                  altText: 'tabletas',
                },
                heading: 'Tabletas masticables',
              },
            ],
          },
        ],
      },
      // ==========================================
      // Tab: DOLOR POSVACUNA
      // ==========================================
      {
        button: {
          label: 'MALESTAR POSVACUNA',
          ariaLabel: 'MALESTAR POSVACUNA',
        },
        image: {
          src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt827e9ba9107ba745/6a54ff67e91cf50f06faa293/793a846629d88abf1a22c2bf498ff2e1ae8bf7be_(1)_-_Editado.png',
          altText: 'Bebé con dolor por vacuna',
        },
        tabContent: [
          // Slider 1: Solución Pediátrica
          {
            backgroundColor: 'blue',
            heading: 'TEMPRA<sup>®</sup> SOLUCIÓN PEDIÁTRICA',
            subHeading: 'AUXILIAR PARA EL ALIVIO DE FIEBRE Y DOLOR.',
            description: '¿Tu bebé se siente mal? Tempra<sup>®</sup> gotas le ayuda a aliviarlo.',
            image: {
              src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/bltd455963bcb0aa689/6a71b04406284c408c93a4fe/carousel-5.png',
              altText: 'Empaque de Tempra Solución Pediátrica Gotas',
            },
            disclaimer:
              'SI PERSISTEN LAS MOLESTIAS, CONSULTE A SU MÉDICO. No se deje al alcance de los niños. Lea la etiqueta del producto antes de utilizarlo. Reg. San. No. 039M84 SSA VI.',
            button: {
              label: 'VER MÁS',
              ariaLabel: 'Ver más Tempra Gotas',
              link: '/ninos/productos/tempra-solucion-pediatrica-30-ml/',
            },
            icons: [
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt388c9c65fa06e661/6a305d49d99d95db073390ad/ico-paraBebes.svg',
                  altText: 'Icono de 0 a 36 meses',
                },
                heading: 'Para niños de 0 a 36 meses',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt22a49d794b6cdd23/6a305d49722edc969297f8f8/ico-gotero-azul.svg',
                  altText: 'Icono gotero azul',
                },
                heading: 'Con gotero integrado',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt4695230e88989c87/6a2c69056b9ea7677aa55edd/Group.svg',
                  altText: 'Icono 6 horas',
                },
                heading: 'Actúa hasta por 6 h',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/bltf71a6a1aa9e9e925/6a305e1f6db5a4b9f7ed70b2/ico-15min-azul.svg',
                  altText: 'Icono 15 minutos',
                },
                heading: 'Actúa en 15 min',
              },
            ],
          },
          // Slider 2: Jarabe 120ml
          {
            backgroundColor: 'blue',
            heading: 'TEMPRA<sup>®</sup> JARABE',
            subHeading: 'AUXILIAR PARA FIEBRE Y DOLOR',
            description:
              'Tempra<sup>®</sup>, tu auxiliar de confianza para aliviar a tus pequeños.',
            image: {
              src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt9fb516723ed08bc0/6a71b042d692d3ddf566f354/carousel-2.png',
              altText: 'Medicamento Tempra Jarabe para niños junto a fresas frescas',
            },
            disclaimer:
              'SI PERSISTEN LAS MOLESTIAS, CONSULTE A SU MÉDICO. NO SE DEJE AL ALCANCE DE LOS NIÑOS. LEA LA ETIQUETA DEL PRODUCTO ANTES DE UTILIZARLO. Permiso de publicidad No. 203300201B1062. Reg. San. 48690 SSA VI​.',
            button: {
              label: 'VER MÁS',
              ariaLabel: 'Ver más Tempra Jarabe',
              link: '/ninos/productos/tempra-jarabe-infantil-120-ml/',
            },
            icons: [
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt4695230e88989c87/6a2c69056b9ea7677aa55edd/Group.svg',
                  altText: 'Icono de alivio hasta por 6 horas',
                },
                heading: 'Actúa hasta por 6 h',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt040762475bcf01d0/6a2c67b7812b3c8a3c8ed19a/ico-paraninios2a11_(1).svg',
                  altText: 'Icono de niña alegre',
                },
                heading: 'Para niños de 2 a 11 años',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt77d9429bec2015d3/6a2c67b7e6cde6d958b30b6e/ico-termometro-azulF_(1).svg',
                  altText: 'Icono de alivio al dolor y la fiebre',
                },
                heading: 'Auxiliar para fiebre y dolor',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt9c2124494861d9bf/6a2c67b75f1b73dd399d4254/ico-saborFresa_(1).svg',
                  altText: 'Icono de medicamento en Jarabe Tempra sabor fresa',
                },
                heading: 'Sabor a fresa',
              },
            ],
          },
          {
            backgroundColor: 'blue',
            heading: 'TEMPRA<sup>®</sup> MASTICABLE',
            subHeading: 'AUXILIAR PARA EL ALIVIO DE FIEBRE Y DOLOR.',
            description:
              '¿Tu pequeño tiene fiebre o dolor? ¡No te preocupes! Confía en Tempra<sup>®</sup>',
            image: {
              src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/bltcdf242d40330717e/6a71b0425c637049f7106ebd/carousel-3.png',
              altText: 'Tempra masticable 4 a 6 años',
            },
            disclaimer:
              'SI PERSISTEN LAS MOLESTIAS, CONSULTE A SU MÉDICO. No se deje al alcance de los niños. Lea las instrucciones de uso en el empaque. Reg. San. No. 039M84 SSA. VI.',
            button: {
              label: 'VER MÁS',
              ariaLabel: 'Ver más Tempra Masticable 4-6',
              link: '/ninos/productos/tempra-tableta-masticable-infantil-30-tabletas-80mg/',
            },
            icons: [
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt8eb4bf86d4de3487/6a2cd46ebcf977d09a2d0df8/ico-paraninios.svg',
                  altText: 'Icono niños',
                },
                heading: 'Para niños de 4 a 6 años',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt4695230e88989c87/6a2c69056b9ea7677aa55edd/Group.svg',
                  altText: 'Icono 6 horas',
                },
                heading: 'Actúa hasta por 6 h',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt06d196adaf98a993/6a2cd55c8ad5d7928f4e3d8f/ico-tablMasticables.svg',
                  altText: 'Icono tabletas',
                },
                heading: 'Tabletas masticables',
              },
            ],
          },
          // Slider 4: Masticable 6-11
          {
            backgroundColor: 'blue',
            heading: 'TEMPRA<sup>®</sup> MASTICABLE',
            subHeading: 'AUXILIAR PARA EL ALIVIO DE FIEBRE Y DOLOR.',
            description:
              'Con la ayuda de Tempra<sup>®</sup> ni el dolor ni la fiebre detendrán a tus pequeños.',
            image: {
              src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt58db9e42255755a5/6a71b04242103f544e72df0a/carousel-4.png',
              altText: 'Medicamento Tempra Tabletas masticables 160mg',
            },
            disclaimer:
              'SI PERSISTEN LAS MOLESTIAS, CONSULTE A SU MÉDICO. No se deje al alcance de los niños. Lea la etiqueta del producto antes de utilizarlo. Reg. San. No. 039M84 SSA VI.',
            button: {
              label: 'VER MÁS',
              ariaLabel: 'Ver más Tempra Masticable 6-11',
              link: '/ninos/productos/tempra-tableta-masticable-infantil-30-tabletas-160mg/',
            },
            icons: [
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt073093fb79e137f9/6a3054adbc747e0aba4d5fc5/ico-paraninios6a11.svg',
                  altText: 'Icono niños grandes',
                },
                heading: 'Para niños de 6 a 11 años',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt4695230e88989c87/6a2c69056b9ea7677aa55edd/Group.svg',
                  altText: 'Icono 6 horas',
                },
                heading: 'Actúa hasta por 6 h',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt06d196adaf98a993/6a2cd55c8ad5d7928f4e3d8f/ico-tablMasticables.svg',
                  altText: 'Icono tabletas',
                },
                heading: 'Tabletas masticables',
              },
            ],
          },
        ],
      },
      // ==========================================
      // Tab: INFLAMACIÓN
      // ==========================================
      {
        button: {
          label: 'INFLAMACIÓN',
          ariaLabel: 'INFLAMACIÓN',
        },
        image: {
          src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt8906f8a069a53777/6a54ff3919775d1a9c8f643d/c57ee6db-d03f-439a-9d3d-2d47e3674a77.png',
          altText: 'Niña con inflamación',
        },
        tabContent: [
          // Slider 1: Tempra-Fen
          {
            backgroundColor: 'yellow',
            heading: 'TEMPRA-FEN<sup>®</sup>',
            subHeading: 'AUXILIAR PARA DOLOR, FIEBRE E INFLAMACIÓN',
            description:
              'Si tu pequeño se siente mal, confía en Tempra-Fen®, que ayuda a aliviar 3 síntomas en 15 minutos¹.',
            image: {
              src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt4c7073d6dce912ab/6a71b042a4d5b84834377f1a/carousel-1.png',
              altText: 'Medicamento Tempra-fen niños',
            },
            disclaimer:
              '¹Pelen F et al. Treatment of fever: Monotherapy withibuprofen. Ibuprofen pediatric suspension containing100 mg/5 ml, multicentre acceptability studyconducted in hospital. ANN PEDIATR. 1998; 45(10):719−728. 2de Martino, et al. Working Towards anAppropriate Use of Ibuprofen in Children: AnEvidence-Based Appraisal. Drugs. 2017; 77: 1295-1311.*No contiene sacarosa. Formula en el Reg. San. No.092M2016 SSA VI.SI PERSISTEN LAS MOLESTIAS, CONSULTE A SUMÉDICO. No se deje al alcance de los niños. Lea laetiqueta del producto antes de utilizarlo. Reg. San.No. 092M2016 SSA VI.',
            button: {
              label: 'VER MÁS',
              ariaLabel: 'Ver más Tempra-Fen',
              link: '/ninos/productos/tempra-fen-ibuprofeno/',
            },
            icons: [
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt3988ac32550e0c0b/6a2c6de28ad5d7a8254e3d6d/ico_15min-naranja.svg',
                  altText: 'Icono 15 min',
                },
                heading: 'Actúa en 15 min*',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt9039be10a3d607c2/6a2c6f0d910feacdf8f2534d/ico-8hrs-naranja.svg',
                  altText: 'Icono 8h',
                },
                heading: 'Hasta por 8 h',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt306d1208e426a6f7/6a2c6de235de77d2e34ef2c1/ico-sinAzucar-anaranja.svg',
                  altText: 'Icono sin azúcar',
                },
                heading: 'Sin azúcar*',
              },
              {
                image: {
                  src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/blt417b1c1edc3d69d8/6a2c6de2910fea1591f25345/ico-jeringaDosif-naranja.svg',
                  altText: 'Icono jeringa',
                },
                heading: 'Con jeringa dosificadora',
              },
            ],
          },
        ],
      },
    ],
  },
};
